import { get } from 'partial.lenses'

export const getToken = store => get(['auth', 'token'], store)

export const getUserEmail = store => get(['auth', 'userInfo', 'email'], store)
